module.exports = __webpack_public_path__ + "static/sf_3.fde359ff.png";